module.exports = __webpack_public_path__ + "static/media/Currency_Ethereum.f8c7d307.png";